import { render, staticRenderFns } from "./incomeStockMovementPage.vue?vue&type=template&id=0363a9ae&"
import script from "./incomeStockMovementPage.vue?vue&type=script&lang=ts&"
export * from "./incomeStockMovementPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports